import * as React from 'react'
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { toastr } from "react-redux-toastr";
import { cloneDeep } from 'lodash';
import { IMapCenter } from 'src/share/types/common';
import "./LocationSuggester.css";

export interface IGeoLocation {
  center?: IMapCenter;
  countryCode?: string;
  countryName?: string;
  state?: string;
  city?: string;
}

interface ILocationSuggesterProps {
  name?: string;
  address: string;
  disabled: boolean;
  required?: boolean;
  onSelect: (selectedLocation: IGeoLocation) => void;
  onChange: (address: string) => void;
}

const initialSelectChange: IGeoLocation = {};

export const LocationSuggester = (props: ILocationSuggesterProps): React.ReactElement => {
  async function transformGeoLocation(results): Promise<void> {
    const { address_components, formatted_address } = results[0];
    const countryInfo = address_components.find((ac) => ac.types.find(type => type === "country"));
    const state = address_components.find((ac) => ac.types.find(type => type === "administrative_area_level_1")) || {};
    const city = address_components.find((ac) => ac.types.find(type => type === "locality")) || {};
    handleAdressChanged(formatted_address)
    const center = await getLatLng(results[0]);
    const geolocation = {
      center,
      countryCode: countryInfo.short_name,
      countryName: countryInfo.long_name,
      state: state.short_name,
      city: city.long_name
    }
    props.onSelect(geolocation)
  }
  const handleAdressChanged = (address: string) => {
    if (!address) {
      props.onSelect(cloneDeep(initialSelectChange))
    }
    props.onChange(address)
  };
  const handleSelected = async (address: string) => {
    handleAdressChanged(address);
    try {
      const results = await geocodeByAddress(address);
      return transformGeoLocation(results);
    } catch (err) {
      toastr.error("Error", "There was an error fetching the location data")
    }
  };
  const inputProps = {
    type: 'text',
    value: props.address,
    onChange: handleAdressChanged,
    required: true,
    name: 'locationSuggester',
  };
  return (
    <div className="location-suggester">
      <PlacesAutocomplete inputProps={inputProps} {...inputProps} onSelect={handleSelected} >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }): React.ReactElement => (
            <div>
                <input
                  {...getInputProps({
                    placeholder: 'City, state or zip',
                    className: 'form-control',
                    name: props.name || 'locationSuggester',
                    required: props.required,
                    disabled: props.disabled
                  })}
                />
                <div className="autocomplete-dropdown-container">
                  {loading && <div className="suggestion-item">Loading...</div>}
                  {suggestions.map((suggestion, key) => {
                    const className = `suggestion-item ${suggestion.active ? 'active' : ''}`
                    return (
                      <div key={key} {...getSuggestionItemProps(suggestion, { className })}>
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
            </div>
          )}
      </PlacesAutocomplete>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/share/components/LocationSuggester/LocationSuggester.tsx